import React                           from 'react';
import { Jumbotron,
         Modal,
         ListGroup,
         ListGroupItem,
         Alert }                       from 'react-bootstrap';
import { Button, FormGroup, 
         Label, Input,
         FormText, InputGroup,
         InputGroupAddon,
         InputGroupText }              from 'reactstrap';
import { withRouter }                  from 'react-router';
import { connect }                     from 'react-redux';
import { BootstrapTable,
         TableHeaderColumn }           from 'react-bootstrap-table';
import Dock                            from 'react-dock';
import { FaWindowClose }               from 'react-icons/fa';
import { FaTrash }                     from 'react-icons/fa';
import { ClipLoader }                  from 'react-spinners';
import PubSub                          from 'pubsub-js';
import { EmployeeOnboardingConstants } from '../environment';
import { doorsFetchData }              from '../../../../actions/door/doors';
import { searchFetchData }             from '../../../../actions/door/search';
import { saveFetchData }               from '../../../../actions/door/save';

import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

const apiHost = EmployeeOnboardingConstants.WebApiHost;
const MAX     = 50;

class DoorAccess extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      help:      false,
      modal:     false,
      isVisible: false,
      reason:    '',
      search:    '',
      message:   '',
      access: {
        users:  {},
        doors:  {},
        reason: ''
      },
      review: []
    }
    
    this.add    = this.add.bind(this);
    this.help   = this.help.bind(this);
    this.search = this.search.bind(this);
    this.submit = this.submit.bind(this);
    this.toggle = this.toggle.bind(this);
    
    this.handleKeyPress     = this.handleKeyPress.bind(this);
    this.handleReview       = this.handleReview.bind(this);
    this.onDoorRowSelect    = this.onDoorRowSelect.bind(this);
    this.onSetSidebarOpen   = this.onSetSidebarOpen.bind(this);
    this.onUserRowSelect    = this.onUserRowSelect.bind(this);
    this.updateReasonValue  = this.updateReasonValue.bind(this);
    this.updateSearchValue  = this.updateSearchValue.bind(this);
  }
  
  ///////////////////////////////
  ////// Framework Methods //////
  ///////////////////////////////
  componentDidMount() {
    this.token = PubSub.subscribe('onboarding.door.save', this.subscriber.bind(this));
    this.props.fetchDataSearch(apiHost, { search: 'SEARCH_RESET' }, true);
    this.props.fetchDataDoors(apiHost);
  }
  
  componentWillUnmount(){
    PubSub.unsubscribe(this.token);
  }
  
  ////////////////////////////
  ////// Helper Methods //////
  ////////////////////////////
  subscriber(msg, data){
    if (msg === "onboarding.door.save") {
      var message = 'Request ' + data.SR + ' received. ' +
        'You will be notified via e-mail when the request is complete. ' +
        'Please contact AccessControl@boisestate.edu with any questions.';
        
      this.setState({
        help:      false,
        modal:     false,
        isVisible: false,
        reason:    '',
        search:    '',
        message:   message,
        access: {
          users:  {},
          doors:  {},
          reason: ''
        },
        review: []
      });
        
      this.props.fetchDataSearch(apiHost, { search: 'SEARCH_RESET' }, true);
    }
  }
  
  add() {
    if (Object.keys(this.state.access.users).length > 0 &&
        Object.keys(this.state.access.doors).length > 0 &&
        this.state.reason !== '') {
            
      let review = this.state.review.slice(0);
      let access = Object.assign({}, this.state.access);
      access.reason = this.state.reason;
      review.push(access);
      var empty = {
        users:  {},
        doors:  {},
        reason: ''
      };
    
      this.setState({access: empty, review: review, search: ''}, function() {
        this.props.fetchDataSearch(apiHost, { search: this.state.search }, true);
      });
    }
    else {
      this.help();
    }
  }
  
  help() {
    this.setState({
      help: !this.state.help
    });
  }
  
  search() {
    if (this.state.search.length > 3) {
      this.setState({ message: '' }, function() {
        this.props.fetchDataSearch(apiHost, { search: this.state.search });
      });
    }
  }
  
  submit() {
    var list = [];
    this.state.review.map(key => (
      Object.keys(key.users).map(user => (
        Object.keys(key.doors).map(door => (  
          list.push(
            {
              reason: key.reason,
              user: key.users[user].dn,
              userFriendly: key.users[user].name,
              group: key.doors[door].dn,
              groupFriendly: key.doors[door].cn
            }
          )
        ))
      ))
    ));
    
    this.props.fetchDataSave(apiHost, list);
    this.toggle();
  }
  
  toggle() {
    this.setState({ isVisible: false }, function() {
      this.setState({
        modal: !this.state.modal
      });
    });
  }
  
  handleKeyPress(e) {
    if (e.key === 'Enter') {
      this.search();
    }
  }
  
  handleReview(key, index, type) {
    let old    = this.state.review.slice(0);
    var review = old[index];
    if (type === 'users') {
      delete review.users[key];
    }
    else if (type === 'doors') {
      delete review.doors[key];
    }
    
    if (Object.keys(review.users).length === 0 || Object.keys(review.doors).length === 0) {
      old.splice(index, 1);
    }
    
    this.setState({review: old});
  }
  
  onDoorRowSelect(row, isSelected) {
    let old = Object.assign({}, this.state.access);
    var key = row.building+row.cn;
    if (isSelected) {
      old.doors[key] = row;
    }
    else {
      delete old.doors[key];
    }
    
    this.setState({ access: old });
  }
  
  onSetSidebarOpen() {
    this.setState({ isVisible: !this.state.isVisible });
  }
  
  onUserRowSelect(row, isSelected) {
    let old = Object.assign({}, this.state.access);
    if (isSelected) {
      old.users[row.dn] = row;
    }
    else {
      delete old.users[row.dn];
    }
    
    this.setState({ access: old });
  }
  
  updateReasonValue(evt) {
    this.setState({
      reason: evt.target.value
    });
  }
  
  updateSearchValue(evt) {
    this.setState({
      search: evt.target.value
    });
  }

  render() {     
    var userOptions = {
      mode:          'checkbox', //radio or checkbox
      clickToSelect: true,
      onSelect:      this.onUserRowSelect
    }
    
    var doorOptions = {
      mode:          'checkbox', //radio or checkbox
      clickToSelect: true,
      onSelect:      this.onDoorRowSelect
    }
    
    return (
      <div>
        <style>
        {`
          .react-bs-select-all {
            display: none
          }
          
          .fade {
            opacity: 100;
          }
        `}
        </style>
        <Jumbotron>
          <h1 style={{fontSize: '45px'}}>Door Access Request Form</h1>
          <p>
            Please use the search feature to locate the individual(s) who have a business
            need to gain badge access to a door.
          </p>
        </Jumbotron>
        <div>
          { this.state.message !== '' ?
            <Alert variant='success'>
              {this.state.message}
            </Alert>
            :
            <span></span>
          }
          <FormGroup>
            <Label for='search' style={{width: 'inherit', marginRight: '5px', float: 'none'}}>Search</Label>
            <FormText color='muted'>
              You can search by first name, last name, login name or e-mail
            </FormText>
            <div className='input-group'>
              <Input type='text' name='search' id='search' placeholder='Please enter a person to search for (minimum 4 characters)' value={this.state.search} onKeyPress={this.handleKeyPress} onChange={evt => this.updateSearchValue(evt)} />
              <span className='input-group-btn'>
                <button className="c-btn c-btn--sm" style={{padding: '4px 42px 1px 14px'}} onClick={this.search}>
                  <span className="c-btn__text">Search</span>
                </button>
              </span>
            </div>
          </FormGroup>
          { this.props.searchIsLoading ?
            <ClipLoader
              color={'#072659'} 
              loading={this.props.searchIsLoading} 
            />
            : <span />
          }
          { !this.props.searchIsLoading && this.props.search.users && this.props.search.users.length > 0 ?
            <div>
              <div style={{marginBottom: '10px'}}>
                { this.props.search.users.length >= MAX ?
                    <Alert bsStyle='warning' style={{marginBottom: '10px'}}>
                      <strong>Warning!</strong> Please refine your search to see more results. Only the top {MAX} results are shown.
                    </Alert>
                  : <span />
                }    
                <InputGroup>
                  <InputGroupAddon addonType='prepend'>
                    <InputGroupText>
                      <BootstrapTable tableBodyClass="catalog-bootstrap-table" data={this.props.search.users} striped={true} hover={true} selectRow={userOptions}>
                        <TableHeaderColumn dataField='key' isKey={true} dataSort={true}>Key</TableHeaderColumn>
                        <TableHeaderColumn dataField='mail' dataSort={true}>E-Mail</TableHeaderColumn>
                        <TableHeaderColumn dataField='name' dataSort={true}>Name</TableHeaderColumn>
                      </BootstrapTable>
                    </InputGroupText>
                  </InputGroupAddon>
                </InputGroup>              
              </div>
              <FormGroup>
                <Label for='reason' style={{width: 'inherit', marginRight: '5px'}}>Reason</Label>
                <FormText color='muted'>
                  Enter the reason they need access
                </FormText>
                  <Input type='textarea' rows='5' name='reason' id='reason' placeholder='Please enter the reason for needing access' value={this.state.reason} onChange={evt => this.updateReasonValue(evt)} />
              </FormGroup>
              <FormGroup>
                <Label for='building' style={{width: 'inherit', marginRight: '5px'}}>Buildings</Label>
                <FormText color='muted'>
                  Please choose the building to grant access to
                </FormText>
                <div>
                  <InputGroup>
                    <InputGroupAddon addonType='prepend'>
                      <InputGroupText>
                        { this.props.doors.length > 0 ? 
                            <BootstrapTable tableBodyClass="catalog-bootstrap-table" data={this.props.doors} striped={true} hover={true} selectRow={doorOptions} pagination search>
                              <TableHeaderColumn dataField='building' dataSort={true}>Building</TableHeaderColumn>
                              <TableHeaderColumn dataField='cn' isKey={true} dataSort={true}>Door</TableHeaderColumn>
                              <TableHeaderColumn dataField='description' dataSort={true}>Description</TableHeaderColumn>
                            </BootstrapTable>
                          :
                          <div></div>
                        }
                      </InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>        
                </div>
              </FormGroup>
            </div>
              :
            <div></div>
          }
          { !this.props.searchIsLoading && this.props.search.users && this.props.search.users.length === 0 ?
            <div style={{marginBottom: '40px'}}>No Results</div>
            :
            <div></div>
          }
        </div>
        
        { !this.props.searchIsLoading && this.props.search.users && this.props.search.users.length > 0 ?
          <button className="c-btn c-btn--sm" style={{marginTop: '10px', marginBottom: '20px', padding: '4px 42px 1px 14px'}} onClick={this.add}>
            <span className="c-btn__text">Add</span>
          </button>
          :
          <div></div>
        }
        { !this.props.saveIsLoading && this.state.review.length > 0 ?
          <button className="c-btn c-btn--sm" style={{ marginTop: '10px', marginBottom: '20px', padding: '4px 42px 1px 14px', float: 'right' }} onClick={this.onSetSidebarOpen}>
            <span className="c-btn__text">Review Changes ({this.state.review.length})</span>
          </button>
          :
          <div></div>
        }
        { this.props.saveIsLoading ?
          <ClipLoader
            color={'#072659'} 
            loading={this.props.saveIsLoading} 
          />
          : <span />
        }
        
        <Dock position='right' isVisible={this.state.isVisible}>
          {/* you can pass a function as a child here */}
          <button style={{float: 'right'}} onClick={this.onSetSidebarOpen}>
            <FaWindowClose size={20} color='black' />
          </button>
          <div style={{marginTop: '50px'}}>
            { this.state.review.map((element, index) => (
              <div key={index}>
                <p style={{marginLeft: '10px'}}><b>Reason</b>: {element.reason}</p>
                <div className="row">
                  <div style={{paddingLeft: '10px'}} className="col-xs-6">
                    <p><b>Users</b></p>
                    <ListGroup>
                      {Object.keys(element.users).map(key => (
                        <ListGroupItem key={key}><button onClick={() => this.handleReview(key, index, 'users')}><FaTrash /></button>{' '}{element.users[key].name}</ListGroupItem>
                      ))}
                    </ListGroup>
                  </div>
                  <div className="col-xs-6">
                    <p><b>Doors</b></p>
                    <ListGroup>
                      {Object.keys(element.doors).map(key => (
                        <ListGroupItem key={key}><button onClick={() => this.handleReview(key, index, 'doors')}><FaTrash /></button>{' '}{element.doors[key].building} - {element.doors[key].cn}</ListGroupItem>
                      ))}
                    </ListGroup>
                  </div>
               </div> 
              </div>
            ))}
            { this.state.review.length > 0 ?
              <button className="c-btn c-btn--sm" style={{marginLeft: '10px', marginTop: '10px', marginBottom: '20px', padding: '4px 42px 1px 14px'}} onClick={this.toggle}>
                <span className="c-btn__text">Submit</span>
              </button>
              :
              <div></div>
            }
          </div>
        </Dock>
        <Modal animation={false} show={this.state.modal}>
          <Modal.Header>Review</Modal.Header>
          <Modal.Body>
            Are you sure you want to submit these door requests?
          </Modal.Body>
          <Modal.Footer>
            <button color='primary' className='c-btn c-btn--sm' onClick={this.submit}>Submit</button>{' '}
            <button color='secondary' className='c-btn c-btn--sm btn-secondary' style={{ color: 'white' }} onClick={this.toggle}>Cancel</button>
          </Modal.Footer>
        </Modal>
        <Modal animation={false} show={this.state.help}>
          <Modal.Header>Help</Modal.Header>
          <Modal.Body>
            Please make sure at least one user, door and a reason message is entered before adding.
          </Modal.Body>
          <Modal.Footer>
            <Button color='primary' onClick={this.help}>Ok</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    doors: state.door.doors.doors,
    doorsHasErrored: state.door.doors.doorsHasErrored,
    doorsIsLoading: state.door.doors.doorsIsLoading,
    search: state.door.search.search,
    searchHasErrored: state.door.search.searchHasErrored,
    searchIsLoading: state.door.search.searchIsLoading,
    save: state.door.save.save,
    saveHasErrored: state.door.save.saveHasErrored,
    saveIsLoading: state.door.save.saveIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDataDoors:  (host)                => dispatch(doorsFetchData(host)),
    fetchDataSave:   (host, params)        => dispatch(saveFetchData(host, params)),
    fetchDataSearch: (host, params, reset) => dispatch(searchFetchData(host, params, reset))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DoorAccess));
